export default __webpack_public_path__ + "bca971df70cdd17e16a38a6cd997b408.png";